// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared visual language for every primary library page linked from AppSidebar.
   SpacesPage is the reference implementation for page headers and spacing. */
:is(.projects-content, .videos-content, .assets-page-content, .reels-page-content,
    .automations-list-content, .characters-page-content, .voices-page-content,
    .integrations-page-content, .workflows-content) {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  padding: 32px 0 64px;
  box-sizing: border-box;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-root);
  min-height: 100%;
  height: auto;
  overflow: visible;
}

:is(.templates-library__title, .projects-title, .videos-title, .assets-page-title, .reels-page-title,
    .automations-list-title, .characters-page-title, .voices-page-title,
    .integrations-page-title, .workflows-title) {
  margin: 0;
  font-family: inherit;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.03em;
}

:is(.templates-library__toolbar, .projects-header-section, .videos-header-section, .assets-page-header-section,
    .reels-page-header-section, .automations-list-header,
    .characters-page-header-section, .voices-page-header-section,
    .integrations-page-header, .workflows-header-section) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  margin-bottom: 24px;
  border: 0;
}

:is(.templates-library__toolbar > div:first-child, .projects-header-copy,
    .videos-header-copy, .assets-page-header-left, .reels-page-header-left,
    .automations-list-header-left, .characters-page-header-left,
    .voices-page-header-left, .integrations-page-header-left, .workflows-header-copy) {
  display: flex;
  flex-direction: column;
  gap: 0;
}

:is(.templates-library__count, .projects-subtitle, .videos-subtitle, .assets-page-subtitle, .reels-page-subtitle,
    .automations-list-subtitle, .characters-page-subtitle, .voices-page-subtitle,
    .integrations-page-subtitle, .workflows-subtitle) {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-text-secondary);
}

:is(.projects-new-button, .videos-create-button, .assets-page-new-button,
    .automations-list-new-btn, .characters-page-new-button, .voices-page-new-button,
    .workflows-new-button) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--color-text-primary);
  border-radius: 7px;
  background: var(--color-text-primary);
  color: var(--color-bg-root);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}

:is(.projects-new-button, .videos-create-button, .assets-page-new-button,
    .automations-list-new-btn, .characters-page-new-button, .voices-page-new-button,
    .workflows-new-button):hover:not(:disabled) {
  background: var(--color-text-primary);
  color: var(--color-bg-root);
  opacity: 0.88;
}

.integrations-page-refresh {
  min-height: 34px;
  padding: 0 12px;
  border-radius: 7px;
}

:is(.projects-search-input, .videos-search-input, .assets-page-search,
    .reels-page-search, .automations-list-search, .characters-page-search,
    .characters-sidebar-search, .voices-page-search) {
  width: min(360px, 100%);
  max-width: 360px;
  height: 46px;
  padding: 0 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 14px;
  box-sizing: border-box;
}

:is(.projects-search-input, .videos-search-input, .assets-page-search,
    .reels-page-search, .automations-list-search, .characters-page-search,
    .characters-sidebar-search, .voices-page-search):focus {
  outline: 0;
  border-color: var(--color-text-secondary);
}

:is(.projects-filters, .videos-toolbar, .assets-page-search-row,
    .reels-page-search-row, .automations-list-search-row,
    .characters-my-search-sticky, .voices-page-search-row) {
  margin-bottom: 18px;
}

:is(.projects-filter-tabs, .characters-tabs, .reels-platform-selector) {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 18px;
  border: 0;
  border-bottom: 1px solid var(--color-border-input);
  border-radius: 0;
  background: transparent;
}

:is(.projects-filter-tab, .characters-tab, .reels-platform-btn) {
  height: 32px;
  padding: 0 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

:is(.projects-filter-tab.active, .characters-tab.active, .reels-platform-btn--active) {
  border-color: var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-root);
}

:is(.projects-gallery, .assets-page-grid, .automations-list-grid,
    .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  margin-top: 28px;
}

/* Adapt the shared gallery language to the shape of each medium. */
.assets-page-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.reels-page-grid {
  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.videos-masonry {
  gap: 18px;
  margin-top: 24px;
}

.characters-tabs {
  margin-bottom: 20px;
}

.characters-tab.active {
  color: var(--color-bg-root);
}

.characters-my-search-sticky {
  padding: 0;
  background: transparent;
}

.reels-platform-selector {
  margin-bottom: 14px;
}

.reels-filterbar {
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
}

.automation-card,
.voice-card {
  padding: 18px;
}

:is(.projects-card, .videos-card, .asset-card, .automation-card,
    .character-card, .voice-card, .reel-card, .workflows-card) {
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

:is(.projects-card, .videos-card, .asset-card, .automation-card,
    .character-card, .voice-card, .reel-card, .workflows-card):hover {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
  transform: translateY(-1px);
}

:is(.projects-empty-state, .videos-empty-state, .assets-page-empty,
    .reels-page-empty, .automations-list-empty, .characters-page-empty,
    .voices-page-empty) {
  margin-top: 28px;
  padding: 42px 20px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
}

@media (max-width: 900px) {
  :is(.projects-gallery, .assets-page-grid, .automations-list-grid,
      .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .assets-page-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  :is(.projects-content, .videos-content, .assets-page-content, .reels-page-content,
      .automations-list-content, .characters-page-content, .voices-page-content,
      .integrations-page-content, .workflows-content) {
    width: calc(100% - 28px);
    padding: 20px 0 48px;
  }

  :is(.templates-library__toolbar, .projects-header-section, .videos-header-section,
      .assets-page-header-section, .reels-page-header-section, .automations-list-header,
      .characters-page-header-section, .voices-page-header-section,
      .integrations-page-header, .workflows-header-section) {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 640px) {
  :is(.projects-gallery, .assets-page-grid, .automations-list-grid,
      .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/SidebarPages.css"],"names":[],"mappings":"AAAA;6EAC6E;AAC7E;;;EAGE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,8EAA8E;EAC9E,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;;;EAGE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,gDAAgD;AAClD;;AAEA;EACE,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;;EAEE,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;;IAGE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;;;;IAIE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["/* Shared visual language for every primary library page linked from AppSidebar.\n   SpacesPage is the reference implementation for page headers and spacing. */\n:is(.projects-content, .videos-content, .assets-page-content, .reels-page-content,\n    .automations-list-content, .characters-page-content, .voices-page-content,\n    .integrations-page-content, .workflows-content) {\n  width: min(1180px, calc(100% - 48px));\n  margin: 0 auto;\n  padding: 32px 0 64px;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-root);\n  min-height: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n:is(.templates-library__title, .projects-title, .videos-title, .assets-page-title, .reels-page-title,\n    .automations-list-title, .characters-page-title, .voices-page-title,\n    .integrations-page-title, .workflows-title) {\n  margin: 0;\n  font-family: inherit;\n  font-size: 25px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n}\n\n:is(.templates-library__toolbar, .projects-header-section, .videos-header-section, .assets-page-header-section,\n    .reels-page-header-section, .automations-list-header,\n    .characters-page-header-section, .voices-page-header-section,\n    .integrations-page-header, .workflows-header-section) {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0;\n  margin-bottom: 24px;\n  border: 0;\n}\n\n:is(.templates-library__toolbar > div:first-child, .projects-header-copy,\n    .videos-header-copy, .assets-page-header-left, .reels-page-header-left,\n    .automations-list-header-left, .characters-page-header-left,\n    .voices-page-header-left, .integrations-page-header-left, .workflows-header-copy) {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n:is(.templates-library__count, .projects-subtitle, .videos-subtitle, .assets-page-subtitle, .reels-page-subtitle,\n    .automations-list-subtitle, .characters-page-subtitle, .voices-page-subtitle,\n    .integrations-page-subtitle, .workflows-subtitle) {\n  margin: 5px 0 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--color-text-secondary);\n}\n\n:is(.projects-new-button, .videos-create-button, .assets-page-new-button,\n    .automations-list-new-btn, .characters-page-new-button, .voices-page-new-button,\n    .workflows-new-button) {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--color-text-primary);\n  border-radius: 7px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n:is(.projects-new-button, .videos-create-button, .assets-page-new-button,\n    .automations-list-new-btn, .characters-page-new-button, .voices-page-new-button,\n    .workflows-new-button):hover:not(:disabled) {\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n  opacity: 0.88;\n}\n\n.integrations-page-refresh {\n  min-height: 34px;\n  padding: 0 12px;\n  border-radius: 7px;\n}\n\n:is(.projects-search-input, .videos-search-input, .assets-page-search,\n    .reels-page-search, .automations-list-search, .characters-page-search,\n    .characters-sidebar-search, .voices-page-search) {\n  width: min(360px, 100%);\n  max-width: 360px;\n  height: 46px;\n  padding: 0 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n:is(.projects-search-input, .videos-search-input, .assets-page-search,\n    .reels-page-search, .automations-list-search, .characters-page-search,\n    .characters-sidebar-search, .voices-page-search):focus {\n  outline: 0;\n  border-color: var(--color-text-secondary);\n}\n\n:is(.projects-filters, .videos-toolbar, .assets-page-search-row,\n    .reels-page-search-row, .automations-list-search-row,\n    .characters-my-search-sticky, .voices-page-search-row) {\n  margin-bottom: 18px;\n}\n\n:is(.projects-filter-tabs, .characters-tabs, .reels-platform-selector) {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0 0 18px;\n  border: 0;\n  border-bottom: 1px solid var(--color-border-input);\n  border-radius: 0;\n  background: transparent;\n}\n\n:is(.projects-filter-tab, .characters-tab, .reels-platform-btn) {\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n:is(.projects-filter-tab.active, .characters-tab.active, .reels-platform-btn--active) {\n  border-color: var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n:is(.projects-gallery, .assets-page-grid, .automations-list-grid,\n    .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n  margin-top: 28px;\n}\n\n/* Adapt the shared gallery language to the shape of each medium. */\n.assets-page-grid {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.reels-page-grid {\n  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.videos-masonry {\n  gap: 18px;\n  margin-top: 24px;\n}\n\n.characters-tabs {\n  margin-bottom: 20px;\n}\n\n.characters-tab.active {\n  color: var(--color-bg-root);\n}\n\n.characters-my-search-sticky {\n  padding: 0;\n  background: transparent;\n}\n\n.reels-platform-selector {\n  margin-bottom: 14px;\n}\n\n.reels-filterbar {\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.automation-card,\n.voice-card {\n  padding: 18px;\n}\n\n:is(.projects-card, .videos-card, .asset-card, .automation-card,\n    .character-card, .voice-card, .reel-card, .workflows-card) {\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  overflow: hidden;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n:is(.projects-card, .videos-card, .asset-card, .automation-card,\n    .character-card, .voice-card, .reel-card, .workflows-card):hover {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n  transform: translateY(-1px);\n}\n\n:is(.projects-empty-state, .videos-empty-state, .assets-page-empty,\n    .reels-page-empty, .automations-list-empty, .characters-page-empty,\n    .voices-page-empty) {\n  margin-top: 28px;\n  padding: 42px 20px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n}\n\n@media (max-width: 900px) {\n  :is(.projects-gallery, .assets-page-grid, .automations-list-grid,\n      .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .assets-page-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  :is(.projects-content, .videos-content, .assets-page-content, .reels-page-content,\n      .automations-list-content, .characters-page-content, .voices-page-content,\n      .integrations-page-content, .workflows-content) {\n    width: calc(100% - 28px);\n    padding: 20px 0 48px;\n  }\n\n  :is(.templates-library__toolbar, .projects-header-section, .videos-header-section,\n      .assets-page-header-section, .reels-page-header-section, .automations-list-header,\n      .characters-page-header-section, .voices-page-header-section,\n      .integrations-page-header, .workflows-header-section) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n@media (max-width: 640px) {\n  :is(.projects-gallery, .assets-page-grid, .automations-list-grid,\n      .characters-page-grid, .voices-page-grid, .workflows-grid, .integrations-grid) {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
